import initialState from 'SRC/modules/redux/initialState'
import actionTypes from 'SRC/modules/redux/actionTypes'

export const vehiclePartOrdersReducer = (state = initialState.vehicleParts.orders, action) => {
  switch (action.type) {
    case actionTypes.SET_VEHICLE_PARTS_ORDER_FORM_DATA:
      return { ...state, deliveryFormData: action.payload }
    case actionTypes.SET_VEHICLE_PARTS_ORDER_CONFIRMATION:
      return { ...state, orderConfirmation: action.payload }
    case actionTypes.SET_VEHICLE_PARTS_ORDER_LOADING:
      return { ...state, isLoading: action.payload }
    case actionTypes.SET_VEHICLE_PARTS_ORDER_SUCCESS:
      return {
        ...state,
        successMessage: action.payload,
        errorMessage: ''
      }
    case actionTypes.SET_VEHICLE_PARTS_ORDER_ERROR:
      return {
        ...state,
        errorMessage: action.payload,
        successMessage: ''
      }
    case actionTypes.SET_VEHICLE_PARTS_ORDER_FINANCING_FORM_DATA:
      return { ...state, financingFormData: action.payload }
    case actionTypes.SET_VEHICLE_PARTS_ORDER_FINANCING_INSTALLMENTS:
      return { ...state, installments: action.payload }
    default:
      return state
  }
}
